// Shopify renders the dynamic checkout button ("shopify-buy-it-now-button")
// client-side in English and does not expose its text via theme locale
// files, so we watch for it and swap it to the Faroese "Keyp nú".
function translateBuyItNowButton() {
  document.querySelectorAll("shopify-buy-it-now-button button").forEach(function (btn) {
    if (btn.textContent.trim() === "Buy it now") {
      btn.textContent = "Keyp nú";
    }
  });
}

translateBuyItNowButton();

new MutationObserver(translateBuyItNowButton).observe(document.body, {
  childList: true,
  subtree: true,
});
